// extracted by mini-css-extract-plugin
export default {"linkButtonBold":"LinkButton_linkButtonBold__6hy0w","linkButton":"LinkButton_linkButton__ZRRo-"};